import Discovery from "./discovery/discovery.module"

const state = {}

const getters = {}

const mutations = {}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  modules: {
    Discovery,
  },
}



// WEBPACK FOOTER //
// ./src/store/aimlabs/aimlabs.module.js